<!--
/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */
-->

<template>
  <span :class="['apcwo-pr-badge', 'apcwo-pr-badge--' + status]">
    {{ label }}
  </span>
</template>

<script>
import {STATUS_LABELS} from '../util/helpers';

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    label() {
      return STATUS_LABELS[this.status] || this.status;
    },
  },
};
</script>

<style>
.apcwo-pr-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background: #e8e8ee;
  color: #4b4b5a;
}
.apcwo-pr-badge--draft {
  background: #fff3d6;
  color: #8a5a00;
}
.apcwo-pr-badge--submitted {
  background: #dce9ff;
  color: #1f4fa3;
}
.apcwo-pr-badge--completed {
  background: #d9f2e0;
  color: #1b6b35;
}
</style>
